import CustomScroll from "@src/component/customScroll";
import { goto } from "@src/route";
import { memo, useState } from "react";
import { Mask } from "antd-mobile";
import "./index.scss";

const Ins = (props: any) => {
  const [upgradeVisible, setUpgradeVisible] = useState(true);

  const toIndex = () => {
    // 服务升级中禁止跳转
    if (upgradeVisible) {
      return;
    }
    goto("/rzIndex" + (props.location.search as string)) //props.location.search
  }

  return (
    <div className="page bottomFit processIndex">
      {/* 服务升级中拦截弹窗 */}
      <Mask visible={upgradeVisible}>
        <div className="holiday-modal">
          <div className="holiday-content">
            <div className="holiday-title">服务升级中</div>
            <div className="holiday-text" style={{ textAlign: 'center' }}>
              敬请期待！
            </div>
          </div>
        </div>
      </Mask>

      <CustomScroll>
        {/* logon */}
        <div className="logo-bg">
          <div className="logo" />
        </div>
        {/* warning */}
        <div className="processTitle">温馨提示： 尊敬的客户</div>
        <div
          className="processDescription">ZEEHO•众行金服融资租赁服务、盗抢保障服务、骑行意外险由ZEEHO合作方成都嘉程智宇信息技术有限公司提供，您的申请即将转入成都嘉程智宇信息技术有限公司并由成都嘉程智宇信息技术有限公司进行审核并办理相应业务。
        </div>

      </CustomScroll>
      {/* normalBtn */}
      <div className="processFooter">
        <div
          className={`button-them bt-normal ${upgradeVisible ? 'disabled' : ''}`}
          onClick={toIndex}
          style={upgradeVisible ? { opacity: 0.5, pointerEvents: 'none' } : {}}
        >
          我知道了
        </div>
      </div>
    </div>
  )
}

export default memo(Ins);